const veterinarians =
{
    helmet :
    {
        title : 'Vétérinaires' ,
        metas : []
    }
};

export default veterinarians ;